import React from "react";
import hero1 from "../images/Image (2).png";
import vector1 from "../images/Vector 1 (1).png";
import hero2 from "../images/Image.png";
import play from "../images/play.png";
import duolingo from "../images/g3.png";
import udemy from "../images/Udemy svg.png";
import trustPilot from "../images/Trustpilot svg.png";
import babel from "../images/Frame.png";

import HeroSwiper from "./HeroSwiper"
const Hero = () => {
  return (
    <main>
    
    <HeroSwiper />

     
    </main>
  );
};

export default Hero;
